'use client';

import { useState } from 'react';

const tabs = [
  {
    id: 'recording',
    label: 'Запись',
    features: [
      { n:'01', t:'Онлайн-запись 24/7', d:'Клиент сам выбирает время, услугу и специалиста. Без звонков, без «напишите в личку». Вы получаете бронь — она идёт автоматически.', tag:'Критично' },
      { n:'02', t:'Telegram-уведомления', d:'Новая запись → сообщение в Telegram с кнопками «Подтвердить» и «Отклонить». Работаете в привычном мессенджере.', tag:'Критично' },
      { n:'03', t:'Напоминания клиентам', d:'Автоматически за 24 часа и за 3 часа до записи. Неявки снижаются на 30–50%. Это прямые деньги в кармане.', tag:'Критично' },
      { n:'04', t:'Умное расписание', d:'Настройте рабочие дни и часы, добавьте особые даты, закройте отпуск одним кликом. Алгоритм сам считает доступные слоты.', tag:'Высокая ценность' },
      { n:'05', t:'Google и Яндекс Календарь', d:'Все брони автоматически появляются в вашем календаре. Внешние события из Яндекса блокируют слоты в расписании.', tag:'Высокая ценность' },
      { n:'06', t:'Личная страница (username)', d:'svoyprofi.ru/u/ваше-имя — ставьте ссылку в шапку Instagram или Telegram. Один клик клиента → запись оформлена.', tag:'Критично' },
    ],
  },
  {
    id: 'crm',
    label: 'Клиенты',
    features: [
      { n:'01', t:'База клиентов', d:'Автоматически собирается из истории броней. Число визитов, суммарная выручка, дата последнего посещения — для каждого клиента.', tag:'Высокая ценность' },
      { n:'02', t:'Заметки и теги', d:'Пишите заметки о клиенте: предпочтения, особенности, договорённости. Ставьте теги: VIP, постоянный, новый. Видите только вы.', tag:'Высокая ценность' },
      { n:'03', t:'VIP-клиенты', d:'Список доверенных клиентов с особыми условиями. Добавляйте вручную или по числу посещений.', tag:'Средняя' },
      { n:'04', t:'Retention-напоминания', d:'Платформа сообщает: «Эти клиенты не приходили уже 30 дней». Email + Telegram. Возвращайте клиентов до того, как они ушли к конкуренту.', tag:'Средняя' },
      { n:'05', t:'Шаблоны сообщений', d:'Готовые тексты для типовых ситуаций: подтверждение, напоминание, ответ на вопрос.', tag:'Средняя' },
      { n:'06', t:'Репутация клиентов', d:'Система считает репутационный скор по числу завершённых броней и неявок. Видите с кем стоит быть осторожнее.', tag:'Дополнительно' },
    ],
  },
  {
    id: 'analytics',
    label: 'Аналитика',
    features: [
      { n:'01', t:'Выручка за период', d:'Сумма выполненных заказов за неделю, месяц или год. Сравнение с предыдущим периодом — тренд в процентах.', tag:'Высокая ценность' },
      { n:'02', t:'Статистика броней', d:'Общее число, завершённые, активные, отменённые, неявки. Полная картина загрузки.', tag:'Высокая ценность' },
      { n:'03', t:'Просмотры профиля', d:'Сколько человек смотрели вашу страницу. Ежедневный email-дайджест в 19:00.', tag:'Высокая ценность' },
      { n:'04', t:'Конверсия откликов', d:'На бирже заявок: сколько откликов отправлено, сколько выбрал клиент. Конверсия в процентах.', tag:'Средняя' },
      { n:'05', t:'Дашборд «сегодня»', d:'Брони на сегодня, выручка за неделю, рейтинг, непрочитанные уведомления — всё сразу на главном экране.', tag:'Высокая ценность' },
      { n:'06', t:'Тренды по периодам', d:'Сравнение текущего периода с предыдущим аналогичным. Растёт бизнес или стагнирует — видно сразу.', tag:'Высокая ценность' },
    ],
  },
  {
    id: 'team',
    label: 'Команда',
    features: [
      { n:'01', t:'Страница бренда', d:'Единая публичная страница салона: лого, описание, услуги, команда, отзывы, адреса. Клиент записывается к бренду — не к мастеру.', tag:'Критично' },
      { n:'02', t:'Управление командой', d:'Добавляйте специалистов, назначайте локации, настраивайте роли. Каждый мастер видит своё расписание, владелец — всё.', tag:'Критично' },
      { n:'03', t:'Единый журнал записей', d:'Все брони ко всем мастерам в одном месте. Фильтрация по специалисту, дате, статусу.', tag:'Критично' },
      { n:'04', t:'Несколько локаций', d:'Два, три, пять адресов под одним брендом. Клиент выбирает удобный. Вы управляете всей сетью из одного кабинета.', tag:'Высокая ценность' },
      { n:'05', t:'Скрытие профилей мастеров', d:'Клиент видит бренд, а не личные страницы сотрудников. Мастер уходит — клиентская база остаётся у вас.', tag:'Критично' },
      { n:'06', t:'Автоподтверждение', d:'30+ записей в день — включите автоматическое подтверждение. Не нужен отдельный администратор.', tag:'Критично' },
    ],
  },
  {
    id: 'integrations',
    label: 'Интеграции',
    features: [
      { n:'01', t:'Telegram-бот', d:'Новая запись, подтверждение, отмена — всё через Telegram. Кнопки прямо в чате: Принять / Отклонить / Написать клиенту.', tag:'Критично' },
      { n:'02', t:'MAX-бот', d:'Уведомления и управление записями в мессенджере MAX. Подходит для тех, кто не использует Telegram.', tag:'Активно' },
      { n:'03', t:'Яндекс Алиса', d:'Голосовые брони: клиент говорит — бронь создаётся. Поиск специалистов, запись, отмена — всё голосом через умные колонки и экосистему Яндекса.', tag:'Активно' },
      { n:'04', t:'Google Календарь', d:'Брони автоматически появляются в Google Calendar. Внешние события блокируют слоты в расписании.', tag:'Высокая ценность' },
      { n:'05', t:'Яндекс Календарь', d:'Аналогично Google — синхронизация броней в обе стороны через Яндекс OAuth.', tag:'Высокая ценность' },
      { n:'06', t:'Email + Push уведомления', d:'Напоминания клиентам по email и push за 24ч и 3ч. Дайджест просмотров профиля в 19:00 ежедневно.', tag:'Критично' },
    ],
  },
];

export default function FeatureTabs() {
  const [active, setActive] = useState(0);

  return (
    <>
      <div className="lp-features-tabs">
        {tabs.map((tab, i) => (
          <button
            key={tab.id}
            className={`lp-ftab${i === active ? ' active' : ''}`}
            onClick={() => setActive(i)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="lp-feat-content active">
        {tabs[active].features.map((f, i) => (
          <div key={i} className="lp-feat-card">
            <div className="lp-feat-num">{f.n}</div>
            <div className="lp-feat-title">{f.t}</div>
            <div className="lp-feat-text">{f.d}</div>
            <span className="lp-feat-tag">{f.tag}</span>
          </div>
        ))}
      </div>
    </>
  );
}
